import { render, staticRenderFns } from "./TDSDatePicker.vue?vue&type=template&id=be731df2"
import script from "./TDSDatePicker.vue?vue&type=script&lang=ts"
export * from "./TDSDatePicker.vue?vue&type=script&lang=ts"
import style0 from "./TDSDatePicker.vue?vue&type=style&index=0&id=be731df2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports